import {
  HStack,
  Icon,
  Text,
  ThemeColorPath,
  ThemeColorTextPath,
  ThemeIconKey,
} from 'platform/foundation';
import {match} from 'ts-pattern';

import {always} from 'ramda';

import {Nullish} from 'shared/web';

type IntegrationNotificationLevel = 'info' | 'warning' | 'error' | 'success';

interface IntegrationNotificationProps {
  level?: IntegrationNotificationLevel | Nullish;
  content?: string | Nullish;
  'data-testid'?: string;
}

export function IntegrationNotification(props: IntegrationNotificationProps) {
  const color = match<IntegrationNotificationLevel | Nullish, ThemeColorPath | undefined>(
    props.level
  )
    .with('info', always('severity.informational'))
    .with('warning', always('severity.warning'))
    .with('error', always('severity.danger'))
    .with('success', always('severity.success'))
    .otherwise(always(undefined));

  const icon = match<IntegrationNotificationLevel | Nullish, ThemeIconKey | undefined>(props.level)
    .with('info', always('action/info'))
    .with('warning', always('alert/warning'))
    .with('error', always('alert/error'))
    .with('success', always('action/check_circle'))
    .otherwise(always(undefined));

  return (
    <HStack spacing={1} align="center">
      <Icon size={4} value={icon} color={color} />
      <Text size="xSmall" color={color as ThemeColorTextPath | undefined}>
        {props.content}
      </Text>
    </HStack>
  );
}
